import type { ApiInternshipId } from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

import type { ApiInternship } from './types/ApiInternship';
import type { ApiUnpublishedInternship } from './types/ApiUnpublishedInternship';

type ApiResponse = {
  data: ApiInternship | ApiUnpublishedInternship;
};

function mapResponse(
  response: ApiResponse,
): ApiInternship | ApiUnpublishedInternship {
  return response.data;
}

const endpoint = new FetchEndpoint({
  urlFactory: (internshipId: ApiInternshipId) =>
    `/data/website/internships/${internshipId}`,
  mapResponse,
});

// Exports

export const listingApiIsomorphicFetchInternship =
  endpoint.createIsomorphicFetchFn();
